import { useVitals } from '@/data/sources/vitals';
import { Flex } from '@/ui';
import { ECGChart } from '../ECGChart/ECGChart';
import { HeartRateIndicator } from '../HeartRateIndicator/HeartRateIndicator';
import styles from './VitalsPopupHandle.module.css';

export const VitalsPopupHandle = () => {
  const heartRate = useVitals().data?.heartRate;

  return (
    <Flex className={styles.root} alignItems="center">
      <div className={styles.ecgChartOffset}>
        <ECGChart heartRate={heartRate} />
      </div>

      <div className={styles.heartRate}>
        <HeartRateIndicator
          heartRate={heartRate}
          size={20}
          fillOpacity={0.25}
        />
      </div>
    </Flex>
  );
};
